import { useCallback, useContext, useEffect, useRef, useState } from "react";
import UploadInput from "./components/UploadInput";
import ExampleCards from "./components/ExampleCards";
import RecentProjectCards from "./components/RecentProjectCards";
import MiddleComp from "../MiddleComp";
import { GenerateContext } from "../hooks/GenerateContext";
import { AppContext } from "@utils/AppContext";
import { IMAGE_TYPE } from "@utils/CONST";
import eventBus from "@utils/eventBus";
import { getFlowProjectPage } from "../FreeCanvas/execution";
import styles from "./index.module.scss";

const CreativeToImage = () => {
    const { projectId, setMatchImages } = useContext(GenerateContext);
    const { setGlobalTaskReadFlag, globalUser } = useContext(AppContext);
    const middleRef = useRef(null);
    const creativeToImageRef = useRef(null);
    const [recentProjects, setRecentProjects] = useState([]);
    const [recentProjectsLoaded, setRecentProjectsLoaded] = useState(false);

    const createClick = () => {
        setGlobalTaskReadFlag((prev) => !prev);
        if (middleRef.current) middleRef.current.fetchProjectDetail();
        if (creativeToImageRef.current) creativeToImageRef.current.scrollTop = 0;
    };

    useEffect(() => {
        const handleCreativeToImageUpload = (url) => {
            if (!url) return;
            setMatchImages([{ url }]);
            if (creativeToImageRef.current) {
                creativeToImageRef.current.scrollTop = 0;
            }
        };

        eventBus.on("creativeToImageAutoUpload", handleCreativeToImageUpload);
        return () => {
            eventBus.off("creativeToImageAutoUpload", handleCreativeToImageUpload);
        };
    }, [setMatchImages]);

    const loadRecentProjects = useCallback(async () => {
        const pageData = await getFlowProjectPage({
            pageIndex: 1,
            pageSize: 4,
            member: globalUser?.id,
            order: 'desc',
            sortField: 'updatedTime',
        });

        setRecentProjects(Array.isArray(pageData?.items) ? pageData.items.slice(0, 4) : []);
    }, [globalUser?.id]);

    useEffect(() => {
        let cancelled = false;

        if (projectId) {
            setRecentProjectsLoaded(false);
            return () => {
                cancelled = true;
            };
        }

        const fetchRecentProjects = async () => {
            try {
                await loadRecentProjects();
                if (cancelled) return;
            } catch (error) {
                if (cancelled) return;
                setRecentProjects([]);
            } finally {
                if (!cancelled) {
                    setRecentProjectsLoaded(true);
                }
            }
        };

        fetchRecentProjects();

        return () => {
            cancelled = true;
        };
    }, [loadRecentProjects, projectId]);

    const showRecentProjects = !projectId && recentProjectsLoaded;
    const showExampleCards = !projectId && recentProjectsLoaded;

    return (
        <div
            className={[
                styles.CreativeToImage,
                projectId ? styles.CreativeToImageGenerating : "",
                "_beauty_scrollbar",
            ].filter(Boolean).join(" ")}
            ref={creativeToImageRef}
        >
            {!projectId && (
                <video className={styles.BgVideo} autoPlay loop muted playsInline>
                    <source
                        src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/creative-to-image/bg.mp4"
                        type="video/mp4"
                    />
                </video>
            )}
            <div className={styles.ContentWrap}>
                {!projectId && (
                    <div className={styles.TitleWrap}>
                        <h2 className={styles.TitleImage}></h2>
                        <p></p>
                    </div>
                )}
                {projectId ? <MiddleComp ref={middleRef} imageType={IMAGE_TYPE.CREATIVE_IMAGE_GEN} /> : null}
                <UploadInput createClick={createClick} routeToFreeCanvasOnGenerate />
                {showExampleCards ? <ExampleCards /> : null}
                {showRecentProjects ? (
                    <RecentProjectCards
                        projects={recentProjects}
                        onReloadProjects={loadRecentProjects}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default CreativeToImage;
